<template>
  <div class="login">
    <div class="mail-link-login">
      <el-input v-model="mailLogin.email" type="email" autocomplete name="mail-link-input" placeholder="메일을 입력하세요"
        :disabled="loginEmailSending"></el-input>
      <br>
      <el-input v-model="mailLogin.passwd" type="password" autocomplete name="mail-link-input" style="padding-top:10px"
        placeholder="패스워드를 입력하세요" :disabled="loginEmailSending"></el-input>

      <el-button type="primary" id="email-login-account-dialog" class="btn" :plain="isPlainButton"
        @click="loginIdPw(mailLogin.email, mailLogin.passwd)" v-loading="loginEmailSending">로그인하기</el-button>
    </div>
    <div class="horizontal-text"><span>소셜로그인</span></div>
    <div class="text-right">
      <el-button type="primary" id="google-login-account-dialog" class="button-block"
        style="background-color:#fff;border-color:#000;color:#000;font-size: 15px;padding:10px 0;vertical-align:middle;"
        :plain="isPlainButton" @click="$firebase.signInGoogle();"><img src="/kr/resume/static/renew_img/icon/google.png"
          style="width:40px;vertical-align: middle;">　Google 계정으로 로그인<br>（자동백업）</el-button>
    </div>
    <p class="addition">이용하시는 Google 계정으로 로그인 할 수 있습니다.</p>
    <div class="text-right">
      <el-button type="primary" id="google-login-account-dialog" class="button-block"
        style="background-color:#fff;border-color:#000;color:#000;font-size: 15px;padding:10px 0;vertical-align:middle;"
        :plain="isPlainButton" @click="$firebase.signInApple();"><img
          src="/kr/resume/static/renew_img/icon/appleinc.png" style="width:40px;vertical-align: middle;">　AppleID로
        로그인<br>（자동백업）</el-button>
    </div>
    <p class="addition">이용하시는 Apple 계정으로 로그인 할 수 있습니다.</p>
    <div class="text-right" v-if="false">
      <el-button type="primary" id="google-login-account-dialog" class="button-block"
        style="background-color:#fff;border-color:#000;color:#000;font-size: 15px;padding:10px 0;vertical-align:middle;"
        :plain="isPlainButton" @click="$firebase.signInFacebook();"><img
          src="/kr/resume/static/renew_img/icon/facebook.png" style="width:40px;vertical-align: middle;">　Facebook로
        로그인<br>（自動バックアップ）</el-button>
    </div>
    <p class="addition" v-if="false">이용하시는 페이스북 계정으로 로그인 가능합니다.</p>
    <div class="horizontal-text"><span>또는</span></div>
    <div class="mail-link-login">
      <el-form ref="mailLoginForm" :model='mailLogin' :rules='mailLoginRules' @submit.native.prevent>
        <el-form-item :required='true' prop='email'>
          <el-input v-model="mailLogin.email" type="email" autocomplete name="mail-link-input"
            placeholder="yagish@example.com" :disabled="loginEmailSending"></el-input>
        </el-form-item>
        <el-button type="primary" id="email-login-account-dialog" class="button-block" :plain="isPlainButton"
          @click="mailSubmit" v-loading="loginEmailSending">메일로 링크보내기<br>（자동백업）</el-button>
      </el-form>
      <p class="addition">메일의 링크를 클릭하는 것만으로 간단하게 로그인할 수 있습니다.</p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
$light-gray: #dcdfe6;

.login {
  max-width: 320px;
  margin: .5rem auto;
  border-radius: .25rem;
  border: solid 1px $light-gray;
  padding: 1rem;
  box-sizing: border-box;

  button {
    margin-top: .5rem;
  }

  .el-form-item {
    margin: 0;
  }

  .addition {
    font-size: .75rem;
    margin: .5rem 0;
  }
}
</style>
<style lang="scss">
.login {
  .el-input {
    position: static;
  }

  .el-form-item__error {
    position: static;
    text-align: left;
  }
}
</style>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      mailLogin: {
        email: ''
      },
      mailLoginRules: {
        email: [
          {
            required: true,
            message: '메일을 입력하세요',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: '메일을 입력하세요',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    resetloginEmail: function () {
      this.mailLogin.email = ''
      this.loginEmailSending = false
      this.$refs['mailLoginForm'].resetFields()
    },
    mailSubmit: function () {
      const app = this
      this.$refs['mailLoginForm'].validate(async valid => {
        if (!valid) {
          return
        }
        app.$firebase.signInEmail(app.mailLogin.email)
        app.loginEmailSending = true
      })
    },
    loginIdPw: function (id, pw) {
      this.fullscreenLoading = true
      this.$firebase.signInEmailPasswd(id, pw)
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>
